var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTPortlet',{attrs:{"title":(_vm.thisLayoutConfig || {}).title,"adBodyStyle":"padding: 0 !important;"}},[_c('template',{slot:"body"},[(_vm.thisLayoutConfig.meta.type === 'iframe')?_c('iframe',{style:(`min-height: ${_vm.thisLayoutConfig.meta.height || '1024px'};`),attrs:{"frameBorder":"0","src":_vm.thisLayoutConfig.meta.url}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }